import { action, computed, makeObservable, observable } from 'mobx';
import { DocumentGroupTypeCode, ProgramDocument } from '../../models';

export class JudgingResourcesPageUiStore {
  @observable programDocumentsByGroup = new Map<DocumentGroupTypeCode, ProgramDocument[]>();

  constructor() {
    makeObservable(this);
  }

  @action
  resetStates(): void {
    this.programDocumentsByGroup.clear();
  }

  @action
  setProgramDocuments(type: DocumentGroupTypeCode, programDocuments: ProgramDocument[]): void {
    this.programDocumentsByGroup.delete(type);
    this.programDocumentsByGroup.set(type, programDocuments);
  }

  @computed
  get getProgramDocuments() {
    return (type: DocumentGroupTypeCode): ProgramDocument[] => {
      return this.programDocumentsByGroup.get(type) || [];
    };
  }
}
